import { Controller } from '@hotwired/stimulus'

// Живое превью карточки рядом с формой «Тренерам»: тренер видит, что получится,
// не отправляя форму.
//
// Превью намеренно не претендует на точность отрисовки карточки в каталоге —
// валюту, переводы языков и порядок тегов считает сервер, и повторять эту логику
// на клиенте значило бы держать две расходящиеся реализации. Здесь показываются
// только те поля, которые тренер только что ввёл, а плейсхолдеры остаются на
// месте, пока поле пустое: пустая карточка пугает сильнее, чем образец.
export default class CoachPreviewController extends Controller {
  static targets = ['fullName', 'languages']

  connect() {
    // Разметку превью рендерит сервер (coach_profiles/_preview_card), поэтому
    // ссылки на её узлы ищем в документе, а не в форме: они лежат в соседней
    // колонке, вне этого контроллера.
    this.preview = {
      name: document.querySelector('[data-preview-target="name"]'),
      tags: document.querySelector('[data-preview-target="tags"]')
    }

    // Запоминаем образец: пока поле пустое, показываем его, а не пустоту.
    this.samples = Object.fromEntries(
      Object.entries(this.preview).map(([key, node]) => [
        key,
        node ? node.innerHTML : ''
      ])
    )

    this.update()
  }

  update() {
    this.renderName()
    this.renderTags()
  }

  renderName() {
    const node = this.preview.name
    if (!node) return

    const value = this.value(this.hasFullNameTarget && this.fullNameTarget)
    node.textContent = value || this.stripTags(this.samples.name)
  }

  // Языки — теми же чипами, что в каталоге; пола в ряду нет ни здесь, ни там.
  // Языки тренер вводит строкой через запятую, поэтому здесь просто режем по
  // запятой: нормализацию в коды языков делает сервер
  // (CoachesHelper::LANGUAGE_CODE_ALIASES), и дублировать её таблицу в JS незачем.
  renderTags() {
    const node = this.preview.tags
    if (!node) return

    const languages = this.value(
      this.hasLanguagesTarget && this.languagesTarget
    )
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
    const parts = languages.slice(0, 2)
    if (languages.length > 2) parts.push(`+${languages.length - 2}`)

    if (!parts.length) {
      node.innerHTML = this.samples.tags
      return
    }
    node.innerHTML = parts.map((text) => this.tagMarkup(text)).join('')
  }

  tagMarkup(text, mod = 'black') {
    const div = document.createElement('div')
    div.textContent = text
    return `<li><span class="tag tag--${mod} tag--s">${div.innerHTML}</span></li>`
  }

  value(input) {
    return input ? input.value.trim() : ''
  }

  stripTags(html) {
    const div = document.createElement('div')
    div.innerHTML = html
    return div.textContent.trim()
  }
}
